import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledComparisonTray = styled.div<{ isCollapsed?: boolean }>`
  padding: ${({ isCollapsed }) => (isCollapsed ? '0' : `${toRem(0)} ${toRem(24)} ${toRem(24)} ${toRem(24)}`)};
  background-color: ${baseVariables.color.base20};
  border: ${toRem(1)} solid ${baseVariables.color.neutral20};
  border-radius: ${toRem(12)} ${toRem(12)} 0 0;
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  .compare-cards {
    justify-content: space-between;
  }
  .clear-btn {
    cursor: pointer;
    text-decoration: underline;
    border-bottom: 1px solid;
    line-height: unset;
    span[data-testid='web-ui-kit-AIcon'] {
      display: none;
    }
    .btn-label {
      line-height: unset;
    }
  }

  .tray-actions {
    .col-12 {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .container {
    padding: 0;

    @media ${baseVariables.mediaQuery.md} {
      padding: 0 ${toRem(16)};
    }
  }
  .cta-wrapper {
    width: 100%;

    .col-12 {
      padding-left: 0;
      padding-right: 0;
    }

    .text-center {
      width: 100%;
    }

    .compare-button {
      width: 100%;
    }
  }
  .m-message-inline {
    .m-message-content {
      ul {
        padding-left: ${toRem(0)};
      }
      li {
        list-style: none;
      }
    }
  }
`;
